import React, { Fragment } from 'react'
import * as ReactDOM from 'react-dom'
import { Icon } from 'antd'
import './index.less'

let globalDialogInstance: any[] = []

export interface DialogProps {
	title?: string
	top?: number
	width?: number
	height?: number
	maxHeight?: number
	maxWidth?: number
	fullScreen?:boolean
}

export default {
	open<P>(component?: React.ReactElement<P>, props?: DialogProps,render?:JSX.Element | string): Promise<any> {
		return new Promise(resolve => {
			props = props || {} as DialogProps
			let fullWidth = (document.documentElement.clientWidth || document.body.clientWidth || window.innerWidth) 
			let fullHeight = (document.documentElement.clientHeight || document.body.clientHeight || window.innerHeight)
			let maxWidth = fullWidth - 150;
			let maxHeight = fullHeight -100;
			let width = props.fullScreen? maxWidth : (props.width || 500)
			let height = props.fullScreen? maxHeight : (props.height || 300)
			width = width > maxWidth ? maxWidth : width;
			height = height > maxHeight ? maxHeight : height;
			let left = (fullWidth - width) / 2;
			let top = (fullHeight - height) / 2;
			let title = props.title || ''
			let hiddenHeader =  (title==='')
			/*设置app-dialog-body的高度*/
			let bodyHeight = hiddenHeader?height :height - 40;

			let div = document.createElement('div')
			div.className = 'app-dialog-main'
			document.body.appendChild(div)
			document.body.style.overflow = 'hidden'
			let onClose = () => {
				this.close()
				resolve()
			}

			let dialogHeader = (
			<div className="app-dialog-head">
				<label>{title}</label>
				<div className="app-dialog-close" onClick={onClose}>
					<Icon type="close" />
				</div>
			</div>);

			let content = (
				<Fragment>
					<div className="app-dialog" style={{ left, top, width, height }}>
						{hiddenHeader ? null: dialogHeader}
						<div className="app-dialog-body" style={{ height: bodyHeight }}>
							{component || render || ''}
						</div>
					</div>
					<div className="app-dialog-shadow"></div>
				</Fragment>
			)

			ReactDOM.render(content, div)
			globalDialogInstance.push(div)
		})
	},
	close() {
		requestAnimationFrame(() => {
			if(globalDialogInstance.length === 0) return;
			let div = globalDialogInstance.pop()
			const unmountResult = ReactDOM.unmountComponentAtNode(div)
			if (unmountResult && div.parentNode) {
				div.parentNode.removeChild(div)
			}
		})
	},
}




// WEBPACK FOOTER //
// ./src/qcc/AppDialog/index.tsx